<script setup>
// ============================================================================
// BonBoZ: "Tổng quan về trang" — HAI ĐƯỜNG cùng một trục, kiểu Pancake.
//
// Một trục là đúng ở đây, khác hẳn `BieuDoTongQuan.vue`: bình luận và tin nhắn
// cùng đơn vị (lượt) nên so trực tiếp được, và chính khoảng cách giữa hai đường
// mới là thứ cần thấy — kênh nào đang mang khách về. Thêm trục thứ hai là bịa
// ra một khoảng cách không có thật.
//
// Tô nền nhạt dưới đường: hai đường không chồng lên nhau (bình luận gần như
// luôn nằm dưới) nên nền không che gì, mà lại đọc được ngay đường nào lớn hơn.
// ============================================================================
import { computed } from 'vue';
import { Chart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Tooltip,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';
import { mauCss } from 'dashboard/helper/mauBieuDo';

const props = defineProps({
  nhan: { type: Array, default: () => [] },
  binhLuan: { type: Array, default: () => [] },
  tinNhan: { type: Array, default: () => [] },
  tenBinhLuan: { type: String, default: '' },
  tenTinNhan: { type: String, default: '' },
});

// Đăng ký ở thân module, cùng lý do đã ghi ở `BieuDoTron.vue`: onMounted của
// component CHA chạy SAU của con, mà `<Chart>` dựng biểu đồ ngay trong
// onMounted của nó.
ChartJS.register(
  Tooltip,
  LineElement,
  LineController,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const duong = (ten, so, bien) => ({
  label: ten,
  data: so,
  borderColor: () => mauCss(bien),
  backgroundColor: () => mauCss(bien, 0.1),
  pointBackgroundColor: () => mauCss(bien),
  borderWidth: 2,
  pointRadius: 0,
  pointHoverRadius: 5,
  tension: 0.4,
  fill: true,
});

const duLieu = computed(() => ({
  labels: props.nhan,
  datasets: [
    duong(props.tenBinhLuan, props.binhLuan, '--bonboz-xong'),
    duong(props.tenTinNhan, props.tinNhan, '--bonboz-mo'),
  ],
}));

const tuyChon = {
  maintainAspectRatio: false,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    // Chú giải do trang cha vẽ bằng HTML: dịch được, đặt đúng chỗ Pancake đặt,
    // và không bấm nhầm làm ẩn mất một đường.
    legend: { display: false },
    tooltip: {
      callbacks: { label: c => ` ${c.dataset.label}: ${c.formattedValue}` },
    },
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: { maxRotation: 0, autoSkipPadding: 16, font: { size: 11 } },
    },
    y: {
      beginAtZero: true,
      ticks: { precision: 0, maxTicksLimit: 3, font: { size: 11 } },
      grid: { drawTicks: false },
      border: { display: false },
    },
  },
};
</script>

<template>
  <Chart type="line" :data="duLieu" :options="tuyChon" />
</template>
